export const formatAmount = (amount = "0", decimals = 3) => {
  let val = parseFloat(amount).toFixed(decimals);
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
